import { render, staticRenderFns } from "./DeptRoleDataruleModal.vue?vue&type=template&id=beb78cfe&scoped=true"
import script from "./DeptRoleDataruleModal.vue?vue&type=script&lang=js"
export * from "./DeptRoleDataruleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb78cfe",
  null
  
)

export default component.exports